/**
 * @format
 */
 export const TOGGLE_CE_JOB_LOADING = 'toggle_ce_job_loading';

 export const SET_CLIENTS = 'set_clients';
export const TOGGLE_CLIENT_LIST_LOADING = 'toggle_client_list_loading';